/**
 * Created by Angela on 06/01/2023.
 * Description:
 * Add contact panel activity component
 *
 * ------ maintenance history ------
 */
import { Component, OnInit, ChangeDetectorRef, Input, ViewChild, OnDestroy } from '@angular/core';
import { businessConstants } from '../../../constants/business.constants';
import { ContactInformationItemDetail, ContactInformationItemType } from '../../contact-detail-new/contact-detail-template/contact-information-item/contact-information-item.model';
import { ThreadDetailService } from '../../../services/thread-detail.service';
import { ContactActivityDataCatgory, ContactBasicInformationCategory, ContactComponentActionTypes, ContactComponentCategory } from '../../contact-detail-new/contact-body-detail.model';
import { ContactDetailService } from '../../contact-detail-new/contact-body-detail.service';
import { ContextMenuComponent, ContextMenuService } from '@perfectmemory/ngx-contextmenu';
import { of, Subscription, Observable, forkJoin, fromEvent, } from 'rxjs';
import { DatePipe } from '@angular/common';
import { OperationType, Processor, QuickTask, SubTask } from '../../../tamalelibs/models/workflow.model';
import { SlideSheetService } from '../../../services/slide-sheet.service';
import { SlideSheetActionTypes, SlideSheetEventTypes } from '../../slide-sheet/slide-sheet.model';
import { WorkflowTaskService } from '../../../tamalelibs/services/workflow-task.service';
import { catchError, map, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from '../../../redux';
import { WorkflowTaskActionTypes } from '../../../tamalelibs/redux/actions/workflow-task.actions';
import { ContactService } from '../../../tamalelibs/services/contact.service';
import { StringLiteralsPipe } from '../../../pipes/translate.pipe';

@Component({
    selector: 'tam-contact-panel-activity',
    templateUrl: './contact-panel-activity.component.html',
    styleUrls: ['./contact-panel-activity.component.scss']
})
export class ContactPanelActivityComponent implements OnInit, OnDestroy {
    @Input() config;
    @ViewChild('contextItemMenu', { static: false }) itemMenuEle: ContextMenuComponent<any>;

    // #region public properties
    activityItems: Array<any>; // for different tab, it will get related activity
    // from the old 7 days and later 7 days
    activitySearchCondition = {
        startDate: this._getDateAfterDays(-7)
    };
    // title
    activityHistory = StringLiteralsPipe.translate('crm.activity_history');
    allHistoryList: Array<ContactInformationItemDetail> = [];
    allupcomingOverdueList: Array<ContactInformationItemDetail> = [];
    // events title
    calendarHistory = StringLiteralsPipe.translate('crm.calendar_history');
    // Save the data obtained from the server
    contactActivity = {
        overdueTaskList: [],
        upcomingTaskList: [],
        historyNoteList: [],
        historyCalendarList: [],
        upcomingCalendarList: []
    };
    contextMenu: Array<any>;
    historyCalendarList: Array<ContactInformationItemDetail> = [];
    historyNoteList: Array<ContactInformationItemDetail> = [];
    isPageLoading = true;
    isCollapse = false;
    menuItems = ['All', 'Tasks', 'Events', 'Notes'];
    noDataStyle = StringLiteralsPipe.translate('general.none');
    // notes title
    notesHistory = StringLiteralsPipe.translate('crm.notes_history');
    overdueTaskList: Array<any> = [];
    // task title
    overdueTask = StringLiteralsPipe.translate('crm.overdue_task');
    selectedIndex = 0;
    // contextMenu: Array<any>;
    upcomingCalendarList: Array<ContactInformationItemDetail> = [];
    upcomingTaskList: Array<any> = [];
    upcomingOverdue = StringLiteralsPipe.translate('crm.upcoming_overdue'); // will use this title after finishing task tile
    upcomingTask = StringLiteralsPipe.translate('crm.upcoming_task');
    // common title
    upcomingTitle = StringLiteralsPipe.translate('crm.upcoming_title');
    windowSize: number;
    // #endregion

    // #region private properties
    private _destroySubscriptions: Array<Subscription> = [];
    // #endregion

    // #region constructor
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _contactDetailService: ContactDetailService,
        private _contactService: ContactService,
        private _contextMenuService: ContextMenuService<any>,
        private _datepipe: DatePipe,
        private _slideSheetService: SlideSheetService,
        private _store: Store<AppState>,
        private _threadDetailService: ThreadDetailService,
        private _workflowTaskService: WorkflowTaskService,
    ) {
    }
    // #endregion

    // #region public functions
    ngOnInit() {
        if (this.config && this.config.isCollapsed === '1') {
            this.isCollapse = true;
        }
        this._initContextMenu();
        // Initialize data of activity
        this._getActivityTileData();
        this.windowSize = window.innerWidth;
        this._destroySubscriptions.push(
            fromEvent(window, 'resize').subscribe((e: any) => {
                this.windowSize = e.target.innerWidth;
                this.isCollapse = false;
                this._updateChangesToUI();
            }),
            this._contactDetailService.action$.subscribe(res => {
                this._actionMessageHandler(res);
            }),
            // Listening the change of the contact
            this._slideSheetService.slideSheetFeedbackSubject$.subscribe(res => {
                // Update contact note information
                if (res.type === SlideSheetEventTypes.CONTACT_VALUE_CHANGE) {
                    this._setActivityStyleByData();
                    this._changeDetectorRef.detectChanges();
                }
            })
        );
        this._updateChangesToUI();

    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
    }

    // this function is a sub function of getting activty data
    getContactTaskData(): void {
        // this part is for event and note
        this._workflowTaskService.getTaskByAssignee(this.config?.data.contactID, 0)
            .pipe(map(item => item['quick-task-list']), take(1))
            .subscribe((taskList: any) => {
                if (taskList.length > 0) {
                    this._parseContactTaskData(taskList);
                }
                this._contactDetailService.action$.next({
                    type: ContactComponentActionTypes.RELOAD_ACTIVITY,
                    payload: this.contactActivity
                });
                this._changeDetectorRef.detectChanges();
            });
    }

    // this function is a sub function of getting activty data
    getEventAndNoteData(): void {
        // this part is for event and note
        this._contactService.getContactNotesAndCalendar(this.activitySearchCondition)
            .pipe(map(item => item['thread-list']), take(1))
            .subscribe((threadList: any) => {
                if (threadList.length > 0) {
                    this._parseNotesAndEventsData(threadList);
                }
                this._contactDetailService.action$.next({
                    type: ContactComponentActionTypes.RELOAD_ACTIVITY,
                    payload: this.contactActivity
                });
                this._changeDetectorRef.detectChanges();
            });
    }

    // will watch the note or event data's click
    onItemClick(event, item): void {
        if (item.value && item.value.clickable) {
            if (item.value.itemType === ContactInformationItemType.Event ||
                item.value.itemType === ContactInformationItemType.Note) {
                const payload = {
                    threadId: item.value.valueId,
                    isMaximize: false
                };
                this._threadDetailService.open$.next(payload);
            } else if (item.value.itemType === ContactInformationItemType.Task) {
                if (item.value.definitionId) {
                    this._workflowTaskService.getQuickTaskDefinitionById(item.value.definitionId).pipe(
                        catchError(() => of(null)),
                        take(1)
                    ).subscribe(quickTask => {
                        if (quickTask && quickTask['quick-task']) {
                            const task = QuickTask.parse(item.value.taskDefinition);
                            const subTask = new SubTask();
                            task.subTask = quickTask['quick-task'];
                            task.definitionId = item.value.definitionId;
                            task.status = item.value.status;
                            task.priority = item.value.priority;
                            task.remindDate = item.value.remindDate;
                            task.subject = item.value.value;
                            subTask.subTaskId = item.value.subTaskId;
                            subTask.status = item.value.status;
                            subTask.remindDate = item.value.remindDate;

                            this._store.dispatch({
                                type: WorkflowTaskActionTypes.SET_TASK_PROCESSOR,
                                payload: Processor.AssignedToMe
                            });

                            this._slideSheetService.showSlideSheetForQuickTask(event, OperationType.Edit, task, subTask,
                                {
                                    subject: this._slideSheetService.slideSheetActionSubject$,
                                    action: {
                                        type: SlideSheetActionTypes.CLOSE,
                                        payload: null,
                                    },
                                }
                            );
                        }
                    });
                }
            }
        }
        if (this._slideSheetService) {
            this._slideSheetService.slideSheetActionSubject$.next({
                type: SlideSheetActionTypes.CLOSE
            });
        }
    }

    // will watch the meatball click
    onMeatball(event: MouseEvent, item: any): void {
        this._contextMenuService.show(this.itemMenuEle, { x: event.clientX, y: event.clientY });
        event.preventDefault();
        event.stopPropagation();
    }

    onMenuSelect(event): void {
        const type = event.event.target.innerText;
        if (type === ContactComponentActionTypes.COLLAPSE_TILE) {
            // this one is for the tile collapse
            this.isCollapse = true;
            this._contactDetailService.action$.next({
                type: ContactComponentActionTypes.COLLAPSE_TILE,
                payload: {
                    origin: ContactComponentCategory.ContactActivity,
                    originPosition: this.config?.position,
                    seletedTab: this.selectedIndex
                }
            });
        } else if (type === ContactComponentActionTypes.EXPAND_TILE) {
            // this one is for tile expand
            this.isCollapse = false;
            this._contactDetailService.action$.next({
                type: ContactComponentActionTypes.EXPAND_TILE,
                payload: {
                    origin: ContactComponentCategory.ContactActivity,
                    originPosition: this.config?.position,
                    seletedTab: this.selectedIndex
                }
            });
        } else {
            // the last one is for the change component
            // actually, we need use the else-if, so that we can handle other situations
            this._contactDetailService.action$.next({
                type: ContactComponentActionTypes.CHANGE_COMPONENT,
                payload: {
                    origin: ContactComponentCategory.ContactActivity,
                    target: type,
                    originPosition: this.config?.position,
                }
            });
        }
    }


    // will get the tab data for selected tab
    selectChange(currentTabIndex: number): void {
        this.activityItems = [];
        this.selectedIndex = currentTabIndex;
        if (this.selectedIndex === 0) {
            // all
            this.activityItems = [
                {
                    title: this.upcomingOverdue,
                    value: this.allupcomingOverdueList
                },
                {
                    title: this.activityHistory,
                    value: this.allHistoryList
                }
            ];
        } else if (this.selectedIndex === 1) {
            // task
            this.activityItems = [{
                title: this.overdueTask,
                value: this.overdueTaskList
            },
            {
                title: this.upcomingTask,
                value: this.upcomingTaskList
            }];
        } else if (this.selectedIndex === 2) {
            // calendar
            this.activityItems = [{
                title: this.upcomingTitle,
                value: this.upcomingCalendarList
            },
            {
                title: this.calendarHistory,
                value: this.historyCalendarList
            }];
        } else if (this.selectedIndex === 3) {
            // note
            this.activityItems = [
                {
                    title: this.notesHistory,
                    value: this.historyNoteList
                }];
        }
        this._setActivityStyleByData();
        this._contactDetailService.action$.next({
            type: ContactComponentActionTypes.CHANGE_TAB,
            payload: {
                origin: ContactComponentCategory.ContactActivity,
                originPosition: this.config?.position,
                seletedTab: this.selectedIndex
            }
        });
    }

    trackByFn(index, item) {
        return item.id;
    }
    // #endregion

    // #region private functions

    private _actionMessageHandler(action): void {
        if (action.type === ContactComponentActionTypes.RELOAD_ACTIVITY) {
            this._initData(action.payload);
        }
    }

    // Get data from the server
    private _getActivityTileData(): void {
        if (this.config?.data) {
            const observables: Array<Observable<any>> = [
                this._workflowTaskService.getTaskByAssignee(this.config?.data.contactID, 0)
                    .pipe(
                        catchError(() => {
                            return of(null);
                        }),
                        take(1)
                    ),
                this._contactService.getContactNotesAndCalendar(this.activitySearchCondition).pipe(
                    catchError(() => {
                        return of(null);
                    }),
                    take(1)
                )
            ];

            forkJoin(observables).subscribe(responses => {
                if (responses && responses.length > 0) {
                    // 1. fiter the task data
                    const taskList = responses[0] ? responses[0]['quick-task-list'] : [];
                    // 2. get the contact activity data: note and event
                    const threadList = responses[1] ? responses[1]['thread-list'] : [];
                    if ((responses[0] && responses[0]['count'] > 0) || (responses[1] && responses[1]['count'] > 0)) {
                        if (responses[0] && responses[0]['count'] > 0) {
                            this._parseContactTaskData(taskList);
                        }
                        if (responses[1] && responses[1]['count'] > 0) {
                            this._parseNotesAndEventsData(threadList);
                        }
                    } else {
                        this.contactActivity = null;
                    }

                    // because only this part need to get data from server again, so, after handle the data, we can init the page data
                    this.isPageLoading = false;
                    if (this.contactActivity) {
                        this._initData(this.contactActivity);
                    } else {
                        this.historyNoteList = [];
                        this.historyCalendarList = [];
                        this.upcomingCalendarList = [];
                        this.allHistoryList = [];
                    }
                    this._updateChangesToUI();
                }
            });
        }
    }

    // a common function to get the time for later or before days
    private _getDateAfterDays(dayCount): number {
        const currentDay = new Date();
        currentDay.setDate(currentDay.getDate() + dayCount);
        const time = currentDay.getTime();
        return time;
    }
    // init the context menu data
    private _initContextMenu(): void {
        this.contextMenu = [
            { id: ContactBasicInformationCategory.BasicInformation, title: ContactBasicInformationCategory.BasicInformation },
            { id: ContactBasicInformationCategory.ContactInformation, title: ContactBasicInformationCategory.ContactInformation },
            { id: ContactBasicInformationCategory.Employment, title: ContactBasicInformationCategory.Employment },
            { id: ContactBasicInformationCategory.Address, title: ContactBasicInformationCategory.Address },
            { id: ContactBasicInformationCategory.Internet, title: ContactBasicInformationCategory.Internet },
            { id: ContactBasicInformationCategory.Other, title: ContactBasicInformationCategory.Other },
            { id: ContactBasicInformationCategory.Note, title: ContactBasicInformationCategory.Note },
        ];
    }

    // this function is for init the tabs for task tile
    private _initData(inputConfig): void {
        this.historyNoteList = this._parseData(inputConfig.historyNoteList);
        this.historyCalendarList = this._parseData(inputConfig.historyCalendarList);
        this.upcomingCalendarList = this._parseData(inputConfig.upcomingCalendarList);
        this.overdueTaskList = this._parseData(inputConfig.overdueTaskList);
        this.upcomingTaskList = this._parseData(inputConfig.upcomingTaskList);
        this.allHistoryList = this._parseData(inputConfig.historyNoteList.concat(inputConfig.historyCalendarList));
        this.allupcomingOverdueList = this._parseData(inputConfig.overdueTaskList).concat(this._parseData(inputConfig.upcomingCalendarList.concat(inputConfig.upcomingTaskList)));

        // init the first tab data
        this.selectChange(this.config.selectedTab);
        this._updateChangesToUI();
    }

    // this function is a sub function of getting activty data: get task data
    private _parseContactTaskData(taskList: Array<any>): void {
        const date = new Date();
        // currentDate is 20200901, so that need to contrast with due-date
        const currentDate = date.getFullYear() + '' + (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '' + date.getDate();
        // 604800000 is the mile time for 7 days
        const mileTimeForSevenDays = 604800000;
        const currentDateStartTime = new Date(date.toLocaleDateString() + ' 00:00:00').getTime();
        const currentDateEndTime = new Date(date.toLocaleDateString() + ' 24:00:00').getTime();
        const overdueTaskList = [];
        const upcomingTaskList = [];
        const noDueDateTaskList = [];
        // fitler logic:
        // 1. the due date is not exist
        // 2. if exist, need to range from -7 to 7 days
        taskList.filter(item => (item['task-definition']['subject'] && !item['task-definition']['due-date'] ||
            (item['task-definition']['due-date'] &&
                new Date(item['task-definition']['due-date'] + ' 24:00:00').getTime() <= (currentDateEndTime + mileTimeForSevenDays) &&
                new Date(item['task-definition']['due-date'] + ' 00:00:00').getTime() >= (currentDateStartTime - mileTimeForSevenDays))))
            .forEach(element => {
                let temp = null;
                if (element['task-definition']['due-date']) {
                    // if the due date exists, will distinguish them into overdue and incoming task according to the current date
                    if (new Date(element['task-definition']['due-date']).getTime() <= currentDateEndTime) {
                        // for this value, it need to get the task basic information for show
                        // and need to get the information to show the sidesheet when click one item
                        temp = {
                            category: ContactActivityDataCatgory.OverdueTaskList,
                            payload: {
                                title: new Date(element['task-definition']['due-date']).getTime(),
                                value: {
                                    value: element['task-definition']['subject'],
                                    subTaskId: element['id'],
                                    definitionId: element['task-definition']['id'],
                                    clickable: true,
                                    itemType: ContactInformationItemType.Task,
                                    priority: element['task-definition']['priority'],
                                    isInvalid: true,
                                    status: element['status'],
                                    remindDate: element['remind-date'],
                                    taskDefinition: {
                                        'assignee': element['task-definition']['assignee'],
                                        'detail': element['task-definition']['detail'],
                                        'due-date': element['task-definition']['due-date'],
                                        'entities': element['task-definition']['entities'],
                                        'finish-flag': element['task-definition']['finishFlag'],
                                        'finish-number': element['task-definition']['finishNumber'],
                                        'originator': element['task-definition']['originator'],
                                        'submitted-date': element['task-definition']['submitted-date'],
                                    }
                                }
                            }
                        };
                        overdueTaskList.push(temp);
                    } else {
                        // for this value, it need to get the task basic information for show
                        // and need to get the information to show the sidesheet when click one item
                        // this one is for the upcoming task
                        temp = {
                            category: ContactActivityDataCatgory.UpcomingTaskList,
                            payload: {
                                title: new Date(element['task-definition']['due-date']).getTime(),
                                value: {
                                    value: element['task-definition']['subject'],
                                    subTaskId: element['id'],
                                    definitionId: element['task-definition']['id'],
                                    clickable: true,
                                    itemType: ContactInformationItemType.Task,
                                    priority: element['task-definition']['priority'],
                                    status: element['status'],
                                    remindDate: element['remind-date'],
                                    taskDefinition: {
                                        'assignee': element['task-definition']['assignee'],
                                        'detail': element['task-definition']['detail'],
                                        'due-date': element['task-definition']['due-date'],
                                        'entities': element['task-definition']['entities'],
                                        'finish-flag': element['task-definition']['finishFlag'],
                                        'finish-number': element['task-definition']['finishNumber'],
                                        'originator': element['task-definition']['originator'],
                                        'submitted-date': element['task-definition']['submitted-date'],
                                    }
                                }
                            }
                        };
                        upcomingTaskList.push(temp);
                    }
                } else {
                    // if the due date is not existing, will push it in the incoming task list
                    // for this value, it need to get the task basic information for show
                    // and need to get the information to show the sidesheet when click one item
                    temp = {
                        category: ContactActivityDataCatgory.UpcomingTaskList,
                        payload: {
                            title: '',
                            value: {
                                value: element['task-definition']['subject'],
                                subTaskId: element['id'],
                                definitionId: element['task-definition']['id'],
                                clickable: true,
                                itemType: ContactInformationItemType.Task,
                                priority: element['task-definition']['priority'],
                                status: element['status'],
                                remindDate: element['remind-date'],
                                taskDefinition: {
                                    'assignee': element['task-definition']['assignee'],
                                    'detail': element['task-definition']['detail'],
                                    'due-date': element['task-definition']['due-date'],
                                    'entities': element['task-definition']['entities'],
                                    'finish-flag': element['task-definition']['finishFlag'],
                                    'finish-number': element['task-definition']['finishNumber'],
                                    'originator': element['task-definition']['originator'],
                                    'submitted-date': element['task-definition']['submitted-date'],
                                }
                            }
                        }
                    };
                    noDueDateTaskList.push(temp);
                }
            });
        if (noDueDateTaskList.length > 0) {
            noDueDateTaskList.sort((a, b) => {
                const alow = a.payload.value.value.toLowerCase();
                const blow = b.payload.value.value.toLowerCase();
                return alow === blow ? 0 : (alow > blow ? 1 : -1);
            });
        }
        this.contactActivity.overdueTaskList = Array.from(new Set(overdueTaskList));
        this.contactActivity.upcomingTaskList = Array.from(new Set(upcomingTaskList)).concat(Array.from(new Set(noDueDateTaskList)));
        this._changeDetectorRef.detectChanges();
    }

    // the originalArray: [[notelistArray],[calendarArray]]
    // because in the future, we need to add the task, then, we will have three inputs, and we just need to change the input
    // not need to use the concat again
    private _parseData(originalArray: Array<any>): Array<any> {
        const result = [];
        if (originalArray && originalArray.length > 0) {
            // tslint:disable-next-line: radix
            originalArray.map(element => element.payload)
                .sort((a, b) => {
                    const alow = Number(a.title);
                    const blow = Number(b.title);
                    return alow === blow ?
                        (a.value.value.toLowerCase() === b.value.value.toLowerCase() ? 0 : (a.value.value.toLowerCase() > b.value.value.toLowerCase() ? 1 : -1)) : (alow < blow ? 1 : -1);
                })
                .forEach(element => {
                    if (element.title) {
                        result.push({
                            title: this._datepipe.transform(element.title, 'MMM d, y'),
                            value: element.value,
                        });
                    } else {
                        result.push({
                            title: '',
                            value: element.value,
                        });
                    }
                });
            return result;
        } else {
            return [];
        }
    }

    // parse contact note and events
    private _parseNotesAndEventsData(notelist: Array<any>): void {
        const historyNoteList = [];
        const historyCalendarList = [];
        const upcomingCalendarList = [];
        const currentTime = new Date().getTime();
        // first, we need to get the note data
        for (let i = 0, len = notelist.length; i < len; i++) {
            // this var is to control: if the item has been searched, we don't need to go on search in attendes to save performance
            let isNeedToScan = true;
            let temp = null;
            // the note data need to be in latest 7 days from now
            // if the notes has only one item, don't need to use for-in
            if (notelist[i].notes.length === 1) {
                // if the submitter or source is the current contact, we can push the note directly into the array
                // so that we can reduce one foreach
                const singleNoteData = notelist[i].notes[0].data;

                // 1. we need to get the itemType and itemCategory for contact information item
                let itemType = '';
                let itemCategory = '';
                if (notelist[i].notes[0].data['entry-class'] === 'event') {
                    itemType = ContactInformationItemType.Event;
                    if (notelist[i].notes[0].data['display-date'] > currentTime) {
                        itemCategory = ContactActivityDataCatgory.UpcomingCalendarList;
                    } else {
                        itemCategory = ContactActivityDataCatgory.HistoryCalendarList;
                    }
                } else if (notelist[i].notes[0].data['entry-class'] === 'note') {
                    itemType = ContactInformationItemType.Note;
                    itemCategory = ContactActivityDataCatgory.HistoryNoteList;
                }

                // 2. we will get the information for each item
                if (singleNoteData.source.data.id === this.config?.data.contactID ||
                    singleNoteData.submitter.data.id === this.config?.data.contactID) {
                    temp = {
                        category: itemCategory,
                        payload: {
                            title: singleNoteData['display-date'],
                            value: {
                                value: singleNoteData['calculatedTitle'],
                                valueId: singleNoteData['id'],
                                clickable: true,
                                itemType: itemType,
                            }
                        }
                    };
                } else {
                    for (let j = 0, entitiesLen = singleNoteData.entities.data.length; j < entitiesLen; j++) {
                        if (singleNoteData.entities.data[j].data.id === this.config?.data.contactID) {
                            temp = {
                                category: itemCategory,
                                payload: {
                                    title: singleNoteData['display-date'],
                                    value: {
                                        value: singleNoteData['calculatedTitle'],
                                        valueId: singleNoteData['id'],
                                        clickable: true,
                                        itemType: itemType,
                                    }
                                }
                            };
                            if (itemType !== ContactActivityDataCatgory.HistoryNoteList) {
                                isNeedToScan = false;
                            }
                            break;
                        }
                    }
                }

                if (isNeedToScan) {
                    for (let j = 0, propertiesLen = singleNoteData.properties.data.length; j < propertiesLen; j++) {
                        const attendees = singleNoteData.properties.data[j].data;
                        if (attendees.propdef.data.name === 'Attendees' && attendees.value &&
                            attendees.value.indexOf(this.config?.data.contactID) !== -1) {
                            temp = {
                                category: itemCategory,
                                payload: {
                                    title: singleNoteData['display-date'],
                                    value: {
                                        value: singleNoteData['calculatedTitle'],
                                        valueId: singleNoteData['id'],
                                        clickable: true,
                                        itemType: itemType,
                                    }
                                }
                            };
                            break;
                        }
                    }
                }
                // to save the temp data in related array
                if (itemCategory === ContactActivityDataCatgory.HistoryNoteList && temp) {
                    historyNoteList.push(temp);
                } else if (itemCategory === ContactActivityDataCatgory.HistoryCalendarList && temp) {
                    historyCalendarList.push(temp);
                } else if (itemCategory === ContactActivityDataCatgory.UpcomingCalendarList && temp) {
                    upcomingCalendarList.push(temp);
                }
            } else {
                // the notes has more than one item, need to use for-in
                for (let m = 0, notesLen = notelist[i].notes.length; m < notesLen; m++) {
                    const multiNoteData = notelist[i].notes[m].data;
                    let itemType = '';
                    let itemCategory = '';
                    if (notelist[i].notes[m].data['entry-class'] === 'event') {
                        itemType = ContactInformationItemType.Event;
                        if (notelist[i].notes[m].data['display-date'] > currentTime) {
                            itemCategory = ContactActivityDataCatgory.UpcomingCalendarList;
                        } else {
                            itemCategory = ContactActivityDataCatgory.HistoryCalendarList;
                        }
                    } else if (notelist[i].notes[m].data['entry-class'] === 'note') {
                        itemType = ContactInformationItemType.Note;
                        itemCategory = ContactActivityDataCatgory.HistoryNoteList;
                    }

                    if (multiNoteData.source.data.id === this.config?.data.contactID ||
                        multiNoteData.submitter.data.id === this.config?.data.contactID) {
                        temp = {
                            category: itemCategory,
                            payload: {
                                title: multiNoteData['display-date'],
                                value: {
                                    value: multiNoteData['calculatedTitle'],
                                    valueId: multiNoteData['id'],
                                    clickable: true,
                                    itemType: itemType,
                                }
                            }
                        };
                    } else {
                        for (let n = 0, entitiesLen = multiNoteData.entities.data.length; n < entitiesLen; n++) {
                            if (multiNoteData.entities.data[n].data.id === this.config?.data.contactID) {
                                temp = {
                                    category: itemCategory,
                                    payload: {
                                        title: multiNoteData['display-date'],
                                        value: {
                                            value: multiNoteData['calculatedTitle'],
                                            valueId: multiNoteData['id'],
                                            clickable: true,
                                            itemType: itemType,
                                        }
                                    }
                                };
                                if (itemType !== ContactActivityDataCatgory.HistoryNoteList) {
                                    isNeedToScan = false;
                                }
                                break;
                            }
                        }
                        if (isNeedToScan) {
                            for (let j = 0, propertiesLen = multiNoteData.properties.data.length; j < propertiesLen; j++) {
                                const attendees = multiNoteData.properties.data[j].data;
                                if (attendees.propdef.data.name === 'Attendees' && attendees.value &&
                                    attendees.value.indexOf(this.config?.data.contactID) !== -1) {
                                    temp = {
                                        category: itemCategory,
                                        payload: {
                                            title: multiNoteData['display-date'],
                                            value: {
                                                value: multiNoteData['calculatedTitle'],
                                                valueId: multiNoteData['id'],
                                                clickable: true,
                                                itemType: itemType,
                                            }
                                        }
                                    };
                                    break;
                                }
                            }
                        }
                    }

                    // to save the temp data in related array
                    if (itemCategory === ContactActivityDataCatgory.HistoryNoteList && temp) {
                        historyNoteList.push(temp);
                    } else if (itemCategory === ContactActivityDataCatgory.HistoryCalendarList && temp) {
                        historyCalendarList.push(temp);
                    } else if (itemCategory === ContactActivityDataCatgory.UpcomingCalendarList && temp) {
                        upcomingCalendarList.push(temp);
                    }
                }
            }
        }
        this.contactActivity.historyNoteList = Array.from(new Set(historyNoteList));
        this.contactActivity.upcomingCalendarList = Array.from(new Set(upcomingCalendarList));
        this.contactActivity.historyCalendarList = Array.from(new Set(historyCalendarList));
        this._changeDetectorRef.detectChanges();
    }

    private _setActivityStyleByData() {
        // to adjust if the no data show
        this.noDataStyle = 'flex';
        for (let i = 0, len = this.activityItems.length; i < len; i++) {
            if (this.activityItems[i].value.length > 0) {
                this.noDataStyle = 'none';
            }
        }
    }

    private _updateChangesToUI(): void {
        if (!this._changeDetectorRef[businessConstants.common.changeDetectorDestroyedIdentifier]) {
            this._changeDetectorRef.detectChanges();
        }
    }

    // #endregion
}
